// Full-site translation using the free Google Website Translator, driven by our own language dropdown.
// - English is the source language (no Google script is loaded while English is selected).
// - Choosing another language stores the choice, sets Google's `googtrans` cookie and reloads the page;
//   on load the Google script reads that cookie and translates the whole page (also content that loads later).

const COOKIE = 'googtrans';

// our dropdown code -> Google code (everything else is identical)
const TO_GOOGLE = { zh: 'zh-CN' };
const FROM_GOOGLE = { 'zh-CN': 'zh' };

const INCLUDED = ['hi', 'gu', 'ar', 'zh-CN', 'es', 'fr', 'de', 'ru', 'ja', 'ko', 'pt', 'it', 'nl', 'tr', 'th', 'vi', 'id', 'ms', 'ur'].join(',');

let started = false;

export function readTranslateCookie() {
  const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=/[^/]*/([^;]+)`));
  if (!m) return null;
  const g = decodeURIComponent(m[1]);
  return FROM_GOOGLE[g] || g;
}

function clearTranslateCookie() {
  const past = 'Thu, 01 Jan 1970 00:00:00 GMT';
  const host = window.location.hostname;
  document.cookie = `${COOKIE}=; expires=${past}; path=/`;
  document.cookie = `${COOKIE}=; expires=${past}; path=/; domain=${host}`;
  document.cookie = `${COOKIE}=; expires=${past}; path=/; domain=.${host}`;
}

// code = our dropdown code ('en', 'hi', 'zh', ...)
export function setTranslateCookie(code) {
  clearTranslateCookie();
  if (code && code !== 'en') {
    document.cookie = `${COOKIE}=/en/${TO_GOOGLE[code] || code}; path=/`;
  }
}

// Google Translate rewrites text nodes, which can make React throw "removeChild"/"insertBefore" errors
// when it later updates the same nodes. These guards are the widely used workaround.
function patchDomForTranslate() {
  if (typeof Node !== 'function' || !Node.prototype || Node.prototype.__vedyahPatched) return;
  const origRemove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) return child;
    return origRemove.apply(this, arguments);
  };
  const origInsert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, ref) {
    if (ref && ref.parentNode !== this) return newNode;
    return origInsert.apply(this, arguments);
  };
  Node.prototype.__vedyahPatched = true;
}

export function initGoogleTranslate(lang) {
  if (started) return;
  if (!lang || lang === 'en') { clearTranslateCookie(); return; }
  started = true;

  setTranslateCookie(lang); // make sure the cookie matches the saved choice
  patchDomForTranslate();

  if (!document.getElementById('google_translate_element')) {
    const box = document.createElement('div');
    box.id = 'google_translate_element';
    box.className = 'notranslate';
    box.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden';
    document.body.appendChild(box);
  }

  window.googleTranslateElementInit = () => {
    // eslint-disable-next-line no-new
    new window.google.translate.TranslateElement(
      { pageLanguage: 'en', includedLanguages: INCLUDED, autoDisplay: false },
      'google_translate_element'
    );
  };
  const s = document.createElement('script');
  s.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  s.async = true;
  document.body.appendChild(s);
}
